import React, { useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { jsonValue } from '../../types/jsonValue';
import { inputFormValueState, inputFormChangedState } from '../../stores/formState';
import { completedComponentState } from '../../stores/completedComponentState';

interface Option {
  label: string;
  value: jsonValue;
}

export interface CheckBoxProps {
  componentId: string;
  options: Option[];
  optional: boolean;
}

const Select: React.FC<CheckBoxProps> = props => {
  const [value, setValue] = useRecoilState(inputFormValueState(props.componentId));
  const setCompleted = useSetRecoilState(completedComponentState(props.componentId));
  const changed = useRecoilValue(inputFormChangedState(props.componentId));

  const toggleOptions = useMemo(() => {

    return props.options.reduce((ret, option) => {
      ret[String(option.value)] = () => {

        setValue(option.value);
        setCompleted(true);
      }
      return ret;
    }, {} as Record<string, () => void>);
  }, [props.options, setValue, setCompleted]);

  // すすむボタンが押されたとき、デフォルトの条件分岐が設定されている場合にそちらに飛ばない不具合に対応
  // optional でなければ発生せず、このコンポーネント単体だと optional のときはスキップボタンがでるため、それ以外のときのみデフォルト値として空文字をいれておく
  useEffect(() => {
    if (!props.optional) return;
    // スキップボタンの値は空文字
    if (props.options.find(o => o.value === '')) return;
    setValue(prev => prev ?? '');
  }, [props.optional, props.options, setValue])

  return (
    <div className={"select" + (changed ? " changed" : "")}>
      {props.options.map(option =>
        <button key={String(option.value)}
                className={value === option.value ? 'checked' : ''}
                type="button"
                onClick={toggleOptions[String(option.value)]}
        >{option.label}</button>
      )}
    </div>
  );
};

export default Select;
